export default __webpack_public_path__ + "static/char-s-43-ko-0ddebb6e477cbc8e86352122a049bafe.png";